// Translation: Error > Landing > Message (Arabic)
export default Object.freeze({
	fallback: {
		title: ''
	}
})
